import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router';
import { linkHandler } from 'utils/linkHandler';

const VoucherRoute = ({ component: Component, isAuthed, isGuest, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthed && !isGuest ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: linkHandler.get('login'),
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

VoucherRoute.propTypes = {
  isAuthed: PropTypes.bool.isRequired,
  isGuest: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
  location: PropTypes.object
};

export default VoucherRoute;
